module.exports = __webpack_public_path__ + "img/bg_320.f3fac8ff.png";